import React from 'react';
import '../../../css/common/playguides/PlayguideGuidanceNotice.css';

export type PlayguideGuidanceCode = 'teket' | 'eplus' | 'pia' | 'lawson';

const GUIDE_LABELS: Record<PlayguideGuidanceCode, string> = {
  teket: 'Teket',
  eplus: 'イープラス',
  pia: 'チケットぴあ',
  lawson: 'ローチケ',
};

const GUIDE_NOTES: Record<PlayguideGuidanceCode, string[]> = {
  teket: [
    'CSVに含まれる日別実績を取り込みます。取得できた過去日はそれぞれの販売日に反映します。',
    'Teketの販売予定数はサイト別上限の候補にできます。イベント全体の上限へ反映するかは設定時に選びます。',
  ],
  eplus: [
    '初めて反映する時点より前の販売分は日別に分解できないため、最初の反映日に「取得開始以前の繰越」として合算します。連動をやり直した場合も、未反映期間の最初の日は同じ扱いです。',
    '最初の反映日より後は累計値の差分を日別販売数として記録します。返券・キャンセルで累計が減った日はマイナスで反映します。',
    '管理画面に販売枠がない券種は上限を自動確定できません。必要に応じて手動で上限を入力してください。',
  ],
  pia: [
    '取得できる日別実績は各販売日に反映します。照会期間より前など、外部画面で日別に取得できない期間は推測しません。',
    '発売区分や受付が異なる券種は別の外部券種として扱います。必要に応じてCasticart側で同じ券種または別券種へ紐付けます。',
    '現行の照会データでは販売上限を確定できないため、上限は手動入力します。',
  ],
  lawson: [
    '初めて反映する時点より前の販売分は、最初の反映日に「取得開始以前の繰越」として合算します。その後は累計値の差分を日別に記録します。',
    '返券・キャンセルで累計が減った日はマイナスで反映します。複数受付で同じ席種を販売している場合は受付別に券種を確認してください。',
    '複数受付が共通在庫を参照する場合があるため、販売上限を単純合算せず、必要に応じて手動入力します。',
  ],
};

export default function PlayguideGuidanceNotice({
  guideCode,
  compact = false,
}: {
  guideCode: PlayguideGuidanceCode;
  compact?: boolean;
}) {
  return (
    <aside className={`playguide-guidance${compact ? ' is-compact' : ''}`} aria-label={`${GUIDE_LABELS[guideCode]}連動の注意事項`}>
      <strong>{GUIDE_LABELS[guideCode]}連動の注意事項</strong>
      <ul>
        {GUIDE_NOTES[guideCode].map((note) => <li key={note}>{note}</li>)}
      </ul>
      <p>
        一度反映した販売日は自動取得で上書きしません。連動を解除しても記録は残り、必要な日だけ手動入力へ切り替えるか集計対象外にできます。
      </p>
    </aside>
  );
}
